import { Spinner } from '@/Domain/components/Shared/Spinner';

export const CenterSpinner = () => (
  <div className="flex flex-1 items-center justify-center">
    <Spinner className="h-7 w-7 text-foreground" />
  </div>
);
